import { firestore } from '../../firebase';
import { useAppSelector } from 'hooks';
import { Select } from 'antd';
import { If } from 'modules/inventory/types';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AppState } from 'store';

export default function AuditOrgsSelect({
  groupIds,
  orgIds,
  selectedIds,
  hasGroupAccess,
  mode,
  ...rest
}: {
  groupIds: string[];
  orgIds: If<typeof mode, 'multiple', string[], string>;
  selectedIds: (orgIds: If<typeof mode, 'multiple', string[], string>) => void;
  hasGroupAccess?: boolean;
  mode?: 'multiple' | 'tags';
  [key: string]: any;
}) {
  const [orgs, setOrgs] = useState<{ id: string; title: string }[]>([]);
  const userId = useAppSelector((state) => state.user.details.uid);

  useEffect(() => {
    const getData = async () => {
      const refs = await firestore
        .collection('orgs')
        .where(`members.${userId}.uid`, '==', userId)
        .where('auditable', '==', true)
        .get();
      const orgs = refs.docs.map((doc) => ({ id: doc.id, title: doc.data().title }));
      console.log({ orgs });
      setOrgs(orgs);
    };
    if (!userId) return;
    getData();

    return () => {};
  }, [userId]);
  const groupMap = useSelector((state: AppState) => state.groups.groupsMap);
  const groupOptions = groupIds.map((groupId) => ({
    label: groupMap[groupId]?.title,
    value: groupId,
  }));
  const options = orgs
    .sort((a, b) =>
      a.title?.toLowerCase().localeCompare(b.title?.toLowerCase(), 'da', {
        sensitivity: 'base',
        numeric: true,
      })
    )
    .map((org) => ({ label: org.title, value: org.id }));
  console.log({ groupOptions, options });

  return (
    <Select
      {...rest}
      mode={mode}
      style={{ width: '100%' }}
      value={orgIds}
      onChange={(newValue: If<typeof mode, 'multiple', string[], string>) => {
        selectedIds(newValue);
      }}
      placeholder={'Vælg afdelinger...'}
      maxTagCount={'responsive'}
    >
      {/* {hasGroupAccess && groupOptions.length > 0 && (
        <Select.OptGroup key={'group'} label={'Grupper'}>
          {groupOptions.map((group) => (
            <Select.Option key={group.value} value={group.value}>
              {group.label}
            </Select.Option>
          ))}
        </Select.OptGroup>
      )} */}

      {/* <Select.OptGroup key={"site"} label={"Grupper"}>
                {[
                    {
                        label: "Kontrolplan",
                        value: "kontrolplan",
                    },
                    {
                        label: "Sikkerhed",
                        value: "sikkerhed",
                    },
                    { label: "Miljø", value: "miljømål" },
                ].map(group => (
                    <Select.Option key={group.value} value={group.value}>
                        {group.label}
                    </Select.Option>
                ))}
            </Select.OptGroup> */}

      {options.length > 0 && (
        <Select.OptGroup key={'org'} label={'Afdelinger'}>
          {options.map((org) => (
            <Select.Option key={org.value} value={org.value}>
              {org.label}
            </Select.Option>
          ))}
        </Select.OptGroup>
      )}
    </Select>
  );
}
